import { User } from '@frontegg/redux-store/auth/interfaces';

const DEBUG_KEY = 'fd-debug-me';

export interface DebugUserData {
  fronteggUser: User;
}

export function isDebugMode(): boolean {
  return localStorage.getItem(DEBUG_KEY) !== null;
}

export function getDebugData(): DebugUserData | null {
  const raw = localStorage.getItem(DEBUG_KEY);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw) as DebugUserData;
  } catch {
    console.warn('[fd-debug] Failed to parse debug data, clearing.');
    localStorage.removeItem(DEBUG_KEY);
    return null;
  }
}

// The stored token's role and permission claims feed PermissionService too, so
// editing only `roles`/`permissions` in this blob does not lower privileges.
export function persistDebugData(fronteggUser: User): void {
  localStorage.setItem(DEBUG_KEY, JSON.stringify({ fronteggUser }));
}

export function clearDebugData(): void {
  localStorage.removeItem(DEBUG_KEY);
}

export function toggleDebugData(fronteggUser: User | undefined): boolean {
  if (isDebugMode()) {
    clearDebugData();
    console.log('[fd-debug] Debug data cleared. Reload to exit debug mode.');
    return false;
  }
  if (!fronteggUser) {
    console.warn('[fd-debug] Cannot persist — no authenticated user data available.');
    return false;
  }
  persistDebugData(fronteggUser);
  console.log('[fd-debug] User data persisted. Reload to enter debug mode.');
  return true;
}
